import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";

import authReducer from "../features/auth/authSlice";
import userReducer from "../features/user/userSlice";
import layoutReducer from "../features/layout/layoutSlice";
import modalReducer from "../features/modal/modalSlice";
import adminReducer from "../features/admin/adminSlice";
import uyelerAraclarReducer from "../features/uyelerAraclar/uyelerAraclarSlice";
import sigortaReducer from "../features/sigorta/sigortaSlice";
import ilanlarReducer from "../features/ilanlar/ilanlarSlice";
import kayitReducer from "../features/kayit/kayitSlice";
import searchReducer from "../features/search/searchSlice";
import calcReducer from "../features/calc/calcSlice";
import adminSettReducer from "../features/adminSett/adminSettSlice";
import addLoadReducer from "../features/addLoad/addLoadSlice";
import loadListReducer from "../features/loadList/loadListSlice";
import updateLoadReducer from "../features/updateLoad/updateLoadSlice";
import aiControlReducer from "../features/aiControl/aiControlSlice";
import jobListReducer from "../features/joblist/jobListSlice";
import admin2Reducer from "../features/admin2/admin2Slice"
import FirmaSlice from "../features/firma/FirmaSlice";
import nakliyeIndexReducer from "../features/nakliyeIndex/nakliyeIndexSlice"
import eArsivSlice from "../features/e-Arsiv/eArsivSlice";
import registerReducer from "../features/register/registerSlice";
import companyProfileReducer from "../features/companyProfile/companyProfileSlice"
import companyAuthorizationReducer from "../features/companyProfile/companyAuthorizationSlice"

import yellowPagesReducer from "../features/yellowPages/yellowPagesSlice"
import kmCalcReducer from "../features/kmCalc/kmCalcSlice"
import notificationReducer from "../features/notification/notificationSlice"
import blockedUserReducer from "../features/blockedUsers/blockedUserSlice";
import admin3Reducer from "../features/admin3/admin3Slice"
import bolgedekiTekliflerimReducer from "../features/bolgedekiTekliflerim/bolgedekiTekliflerimSlice"
import messageReducer from "../features/messages/messageSlice";
import isOrtaklariReducer from "../features/isOrtaklari/isOrtaklariSlice";
import topPagesMapReducer from "../features/topPagesMap/topPagesMapSlice"
import reportReducer from "../features/reports/reportSlice";
import distanceReducer from "../features/distance/distanceSlice"
import addressReducer from "../features/address/addressSlice"
import aiReducer from "../features/ai/aiSlice"
import nakliyeHesaplamaReducer from "../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import admin4Reducer from "../features/admin4/admin4Slice"
import boundariesReducer from "../features/boundaries/boundariesSlice"
import admin5Reducer from "../features/admin5/admin5Slice"
import locsReducer from "../features/locs/locsSlice"
import loadOwnerReducer from "../features/loadOwner/loadOwnerSlice"

import branchUserLocationsReducer from "../features/branchUserLocations/branchUserLocationsSlice"
import kamyoonRoadReducer from "../features/kamyoonRoad/kamyoonRoadSlice"
import logReducer from "../features/log/logSlice"

import tpmReducer from "../features/tpm/tpmSlice"
import driversVehiclesReducer from "../features/driversVehicles/driversVehiclesSlice"
import loadBulkReducer from "../features/loadBulk/loadBulkSlice"
import shipmentOperationReducer from "../features/shipmentOperation/shipmentOperationSlice"
import registeredAddressReducer from "../features/registeredAddress/registeredAddressSlice"
import driverAddressReducer from "../features/driverAddress/driverAddressSlice"
import dailyShipmentReportReducer from "../features/dailyShipmentReport/dailyShipmentReportSlice"
import gumrukAgcReducer from "../features/gumrukAgc/gumrukAgcSlice"


const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    layout: layoutReducer,
    modal: modalReducer,
    admin: adminReducer,
    uyelerAraclar: uyelerAraclarReducer,
    sigorta: sigortaReducer,
    ilanlar: ilanlarReducer,
    kayit: kayitReducer,
    search: searchReducer,
    calc: calcReducer,
    adminSett: adminSettReducer,
    loadOwner: loadOwnerReducer,
    jobList: jobListReducer,

    aiControl: aiControlReducer,
    addLoad: addLoadReducer,
    updateLoad: updateLoadReducer,
    loadList: loadListReducer,
    admin2: admin2Reducer ,
    nakliyeIndex: nakliyeIndexReducer,

    firma: FirmaSlice,
    eArsiv: eArsivSlice,
    register: registerReducer,
    companyProfile: companyProfileReducer,
    yellowPages:yellowPagesReducer,
    kmCalc: kmCalcReducer,
    companyAuthorization: companyAuthorizationReducer,
    notification: notificationReducer,
    blockedUsers: blockedUserReducer,
    admin3: admin3Reducer,
    bolgedekiTekliflerim: bolgedekiTekliflerimReducer,
    message: messageReducer,
    isOrtaklari: isOrtaklariReducer,
    topPagesMap: topPagesMapReducer,
    report: reportReducer,
    distance: distanceReducer,
    address:addressReducer,
    ai: aiReducer,
    nakliyeHesaplama: nakliyeHesaplamaReducer,
    admin4: admin4Reducer,
    boundaries: boundariesReducer,
    admin5: admin5Reducer,
    locs: locsReducer,
    branchUserLocations: branchUserLocationsReducer,
    kamyoonRoad:kamyoonRoadReducer,

    log: logReducer,
    tpm: tpmReducer,
    driversVehicles: driversVehiclesReducer,
    loadBulk: loadBulkReducer,
    shipmentOperation: shipmentOperationReducer,
    registeredAddress: registeredAddressReducer,
    driverAddress: driverAddressReducer,
    dailyShipmentReport: dailyShipmentReportReducer,
    gumrukAgc: gumrukAgcReducer


    
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
  devTools: process.env.NODE_ENV === 'development'
});

export default store;
